import i18n from 'localization/i18nextConf';
import toast from 'react-hot-toast';
import { secureStorage } from 'utils/secureStorage';

const BASE_URL = import.meta.env.VITE_BLOG_URL;
const activeLanguage = i18n.language ?? 'en';
const appBaseUrl = import.meta.env.VITE_APP_BASE_URL;

const request = async (url: string, options: any = {}) => {
	try {
		options.headers = {
			...options.headers,
			'Accept-Language': activeLanguage,
		};
		const response = await fetch(url, options);

		if (response?.status === 401) {
			handleError(response);
			return {};
		}
		return response.json();
	} catch (error: any) {
		handleError(error);
		return {};
	}
};

export const get = (url: string, options: any = {}) => request(`${BASE_URL}${url}`, options);

export const post = (
	url: string,
	data?: any,
	options: any = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
	},
) => {
	const payload = {
		...data,
	};
	return request(`${BASE_URL}${url}`, {
		...options,
		body: JSON.stringify(payload),
	});
};

export const put = (
	url: string,
	data?: any,
	options: any = {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
	},
) => {
	const payload = {
		...data,
	};
	return request(`${BASE_URL}${url}`, {
		...options,
		body: JSON.stringify(payload),
	});
};

export const del = (
	url: string,
	data?: any,
	options: any = {
		method: 'DELETE',
		headers: {
			'Content-Type': 'application/json',
		},
	},
) => {
	const payload = {
		...data,
	};
	return request(`${BASE_URL}${url}`, {
		...options,
		body: JSON.stringify(payload),
	});
};

export const handleResponse = (response: any) => {
	if (response?.error) {
		handleError(response);
		return;
	}
	return response;
};

export const handleError = async (response: any) => {
	const { status, message } = (await response) ?? {};
	if (status === 401) {
		const { message } = (await response.json()) ?? {};
		toast.error(message ? message : 'Unauthorized. Please log in again.');
		secureStorage.removeItem('auth');
		setTimeout(() => {
			window.location.href = `${appBaseUrl}/login`;
		}, 2000);
	} else {
		if (message) {
			toast.error(message);
		} else {
			console.log('An error occurred.');
		}
	}
};
